import { Clinic } from '../common';

export class ClinicPayment {
    _id: string;
    payment_details: any;
    total_online_amount: number;
    online_due: number;
    total_phone_consultation_amount: number;
    total_phone_consultation_due: number;
    total_online_due: number;
    recieved_amount: number;
    paid_amount: number;
    clinic: Clinic;
    date: string;
}
